// extracted by mini-css-extract-plugin
export default {"fullWidth":"StudyRequestForm_fullWidth__KvVVn","agreementContainer":"StudyRequestForm_agreementContainer__CLuFS"};